import { Fade, Popper, PopperProps } from '@mui/material'
import { JSXElementConstructor } from 'react'

interface SearchBarPopperProps extends Pick<PopperProps, 'placement'>, Partial<PopperProps> {
  open: boolean
  anchorEl: any
}

/**
 * @todo
 * check and remove this as soon as the MUI Popper Prop typings are updated
 */
const requiredProps = {} as {
  nonce: any
  onResize: any
  onResizeCapture: any
}

export const SearchBarPopper: JSXElementConstructor<SearchBarPopperProps> = ({
  open,
  anchorEl,
  children,
  placement,
}) => (
  <Popper
    open={open}
    anchorEl={anchorEl}
    placement={placement ? placement : 'bottom-start'}
    transition
    style={{
      pointerEvents: 'none',
      zIndex: 10,
    }}
    {...requiredProps}
  >
    {({ TransitionProps }) => (
      <Fade {...TransitionProps} timeout={350}>
        <div
          style={{
            pointerEvents: 'auto',
            width: '650px',
            maxWidth: '95%',
            margin: '15px 0 0',
          }}
        >
          {children}
        </div>
      </Fade>
    )}
  </Popper>
)
